import { environment } from 'projects/semeris/src/environments/environment';
import { RootState } from 'projects/semeris/src/store/root-state.model';
import rg4js, { BreadcrumbLevel } from 'raygun4js';

import { LogLevel } from '../../models/log-configuration.model';
import { LogProviderService } from '../log-provider.service';

export class RaygunLoggerService extends LogProviderService {
  constructor() {
    super();

    rg4js('apiKey', environment.raygun.apiKey);
    rg4js('setVersion', environment.version);
    rg4js('enableCrashReporting', environment.raygun.enableCrashReporting);
    rg4js('enablePulse', environment.raygun.enablePulse);
    rg4js('logContentsOfXhrCalls', true);
    rg4js('disableAutoBreadcrumbsConsole');
    rg4js('options', {
      apiEndpoint: environment.raygun.apiEndpoint,
    });
    // setTimeout(() => {
    //   alert('ERROR');
    //   throw new Error('Test Error');
    // }, 30_000);
  }

  public setUser(identifier: string, email: string): void {
    rg4js('setUser', {
      identifier,
      isAnonymous: false,
      email,
    });
  }

  public navigation(path: string, level: LogLevel) {
    this.sendRouteChanges(path);
  }

  public action<T = any>(actionType: string, payload: T) {
    this.sendReduxActionLog(actionType, payload);
  }
  // TODO: Send Store DATA
  public attachStore(store: RootState) {
    //     rg4js('withCustomData', () => {
    //     return { store };
    // });
  }
  // TODO: LogLevel
  public verbose(message: any, optionalParameters?: any[]): void {
    this.sendCustomLog(message, LogLevel.Verbose, optionalParameters);
  }
  public info(message: any, optionalParameters?: any[]): void {
    // this.sendCustomLog(message, LogLevel.Info, optionalParameters);
  }
  public warn(message: any, optionalParameters?: any[]): void {
    this.sendCustomLog(message, LogLevel.Warning, optionalParameters);
  }
  public error(error: Error, customData?: any): void {
    this.sendError(error, customData);
  }

  private sendError(error: Error, customData?: any) {
    rg4js('send', {
      error,
      customData,
    });
  }

  private sendReduxActionLog(actionType: string, payload: any) {
    rg4js(
      'recordBreadcrumb',
      {
        message: actionType,
        metadata: {
          // payload
        },
        level: 'info',
        location: 'redux',
      },
      {}
    );
  }

  private sendCustomLog(message: string, logLevel: LogLevel, optionalParameters?: any[]) {
    let breadcrumbLevel: BreadcrumbLevel = 'info';

    switch (logLevel) {
      case LogLevel.Verbose:
        breadcrumbLevel = 'debug';
        break;
      case LogLevel.Info:
        breadcrumbLevel = 'info';
        break;
      case LogLevel.Warning:
        breadcrumbLevel = 'warning';
        break;
      case LogLevel.Error:
        breadcrumbLevel = 'error';
        break;
    }

    rg4js(
      'recordBreadcrumb',
      {
        message,
        metadata: {
          optionalParameters,
        },
        level: breadcrumbLevel,
        location: 'custom',
      },
      {}
    );
  }

  private sendRouteChanges(path: string) {
    rg4js('trackEvent', { type: 'pageView', path });
  }
}
